/*
 * @Author: Zach
 * @Date: 2022-12-23 18:43:53
 * @LastEditors: romanyuen@qpp.com yuan719...
 * @LastEditTime: 2023-05-12 10:11:28
 */

import { IDataAccessor, AbstractAccessorService } from "@core/data-access";
import { IResponse } from "@core/data-access/model";
import { PartnerInfo } from "@modules/user/model/domain/partner/PartnerInfo";
import { IEShopperInfo } from "@modules/user/rest/partner/iEShopperInfo";
import { IPartnerRestService } from "./partner-rest-service";
import { partnerContact } from "@modules/user/model/domain/partner/partnerContact";
import { appConfig } from "@env/app-config";

export class PartnerRestService extends AbstractAccessorService<PartnerInfo> implements IPartnerRestService {
    public readonly $name: string = "partnerRestService";

    public static readonly $inject: string[] = ["$accessor"];

    constructor(public $accessor: IDataAccessor<PartnerInfo>) {
        super();
    }

    /**
     * @description: 获取e-shopper信息
     * 
     */
    public eshopperInfo(): angular.IPromise<IResponse<IEShopperInfo>> {
        return this.$accessor<IEShopperInfo, {}, string>(this.$name, "eshopperInfo");
    }

    /**
     * @description: 重新发送partner验证邮件
     * 
     */
    public sendmail(): angular.IPromise<IResponse<any>> {
        return this.$accessor<any, {}, string>(this.$name, "sendmail",{
            data: {
                platform: appConfig.websiteCode
            }
        });
    }

    /**
     * @description: partner邮箱验证
     * 
     */
    public verify(token: string | null): angular.IPromise<IResponse<any>> {
        return this.$accessor<any, {}, string>(this.$name, "verify", {
            parameter: {
                token: token
            }
        });
    }

    /**
     * @description: 修改e-shopper信息
     * 
     */
    public updateEShopperInfo(eshopper: IEShopperInfo): angular.IPromise<IResponse<IResponse<IEShopperInfo>>> {
        return this.$accessor<any, {}, string>(this.$name, "updateEShopperInfo", {
            data: eshopper
        });
    }

    /**
     * @description: 修改partner联系信息
     * 
     */
    public updatePartnerInfo(id:number,partnerContact:partnerContact): angular.IPromise<IResponse<boolean>> {
        return this.$accessor<boolean, {}, "updatePartnerInfo">(this.$name, "updatePartnerInfo", {
            parameter: { id: id },
            data: partnerContact,
        });
    }
    
    // TODO: 类型待定义
    public anonymousResendMail(token: string,googleVerifyToken:string): angular.IPromise<IResponse<boolean>> {
        return this.$accessor<boolean, {}, "anonymousResendMail">(this.$name, "anonymousResendMail", {
            data: {
                platform: appConfig.websiteCode,
                token: token,
                googleVerifyToken:googleVerifyToken
            },
        });
    }
}